import { BaseQueryFn, EndpointBuilder, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { APP_ENDPOINTS } from 'app/endpoints';
import { NestedProduct, ResponseNestedProductDto } from '../types/dtos';

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.query<NestedProduct, string>({
        async queryFn(productId, _queryApi, _extraOptions, fetchWithBQ) {
            const nestedProductResult = await fetchWithBQ(`${APP_ENDPOINTS.NESTED_PRODUCT}/${productId}`);

            if (nestedProductResult.error) return { error: nestedProductResult.error as FetchBaseQueryError };

            const nestedProduct = nestedProductResult.data as ResponseNestedProductDto;

            return {
                data: nestedProduct,
            };
        },
        providesTags: [{ type: 'nested-product', id: 'GET' }],
    });
